// extracted by css-extract-rspack-plugin
export default {"cls1":"CourseResults-cls1_Uat","cls2":"CourseResults-cls2_6oN CourseResults-cls1_Uat"};